import React from 'react';
import ReactDOM from 'react-dom';
import "semantic-ui-css/semantic.min.css";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { registerLocale } from  "react-datepicker";
import ru from 'date-fns/locale/ru';
import moment from "moment-timezone";

//moment.tz.setDefault('Asia/Yekaterinburg');

registerLocale('ru', ru)

ReactDOM.render(
    <App/>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


